import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const phoneNumberFieldCssProps = {};

export const c1headerpart = css({
  '.c1-headerpartleft': {
    paddingTop: '30PX',
    paddingRight: '50px',

    [MediaQueries.lg]: {
      paddingRight: '0px',
      paddingTop: '0px',
    },

    [MediaQueries.sm]: {
      paddingBottom: '30px',
      maxWidth: 'none',
      paddingTop: '30px',
      marginLeft: '0%',
      paddingLeft: '0px',
      paddingRight: '0px',
    },

    [MediaQueries.md]: {
      paddingBottom: '30px',
      paddingTop: '0px',
      paddingLeft: '0px',
      maxWidth: 'none',
      marginLeft: '0%',
      paddingRight: '0px',
    },

    h1: {
      marginTop: '10px',
      marginBottom: '24px',
      fontSize: '56px',
      lineHeight: '56px',
      letterSpacing: '-1px',
      textAlign: 'left',
      [MediaQueries.md]: {
        fontSize: '48px',
        lineHeight: '48px',
      },
      [MediaQueries.sm]: {
        fontSize: '48px',
        lineHeight: '48px',
      },
    },

    '.top_p': {
      fontSize: '18px',
      fontStyle: 'normal',
      color: '#747475',
      fontWeight: 500,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'left',
      [MediaQueries.md]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
      [MediaQueries.lg]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
      [MediaQueries.sm]: {
        fontSize: '16px',
        lineHeight: '24px',
      },
    },

    '.description_txt': {
      color: '#393939',
      maxWidth: '416px',

      letterSpacing: '0px',
      textAlign: 'left',
      marginBottom: '24px',

      p: {
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '32px',
        [MediaQueries.lg]: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        [MediaQueries.md]: {
          fontSize: '16px',
          lineHeight: '24px',
        },
        [MediaQueries.sm]: {
          fontSize: '16px',
          lineHeight: '24px',
        },
      },

      [MediaQueries.md]: {
        maxWidth: '100%',
      },
    },

    '.callmesec': {
      display: 'flex',
      maxWidth: '418px',
      [MediaQueries.sm]: {
        display: 'block',
      },
      [MediaQueries.md]: {
        display: 'block',
      },

      [MediaQueries.lg]: {
        maxWidth: '408px',
      },

      '.inputphone': {
        width: '100%',

        '#phoneNumber-helper-text': {
          position: 'absolute',
          fontSize: '14px',
          [MediaQueries.md]: {
            position: 'relative',
          },
          [MediaQueries.sm]: {
            position: 'relative',
          },
        },
        input: {
          [MediaQueries.lg]: {},
          [MediaQueries.md]: {},
        },
      },
      'button:hover': {
        background: '#d42705',
        outlineColor: '#d42705',
      },
      button: {
        borderRadius: '8px',
        fontSize: '14px',
        minHeight: '56px',
        cursor: 'pointer',
        display: 'flex',
        textTransform: 'uppercase',
        minWidth: '120px',
        lineHeight: '18px',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#E52500',
        marginLeft: '16px',
        color: '#fff',
        border: '0px',
        letterSpacing: '0.88px',

        [MediaQueries.sm]: {
          marginLeft: '0px',
          marginTop: '15px',
          minHeight: '56',
          width: '100%',
        },
        [MediaQueries.md]: {
          marginLeft: '0px',
          marginTop: '15px',
          minHeight: '56',
          width: '100%',
        },

        [MediaQueries.lg]: {
          minHeight: '56px',
        },
      },
    },

    '.c1_call_sec': {
      marginTop: '24px',

      b: {
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0px',
        textAlign: 'left',
      },

      a: {
        display: 'flex',
        alignItems: 'center',
        color: '#393939',
        textDecoration: 'none',
        display: 'inline-block',

        '.call_no': {
          display: 'flex',
          marginTop: '0px',
          alignItems: 'center',
          color: '#393939',
          fontWeight: '500',
          i: {
            margin: '0px 10px',
          },
        },

        '.number': {
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '0px',
          textAlign: 'left',
        },
      },
    },
  },

  '.leftsec ': {
    [MediaQueries.xl]: {
      width: '37%',
    },
    [MediaQueries.lg]: {
      width: '45%',
    },
    [MediaQueries.md]: {
      width: '46%',
    },
    [MediaQueries.sm]: {
      order: '2',
    },
  },

  '.rightsec': {
    paddingRight: '0px',
    [MediaQueries.xl]: {
      width: '61%',
    },

    [MediaQueries.lg]: {},

    [MediaQueries.sm]: {
      paddingBottom: '0px',
      order: '1',
    },
  },
});

export const containerPadding = {
  padding: '0px 0 0px !important',
  minHeight: 'auto !important',
  overflow: 'hidden',

  [MediaQueries.md]: {
    paddingBottom: 0,
  },

  [MediaQueries.lgAndUp]: {
    paddingBottom: 64,
  },
};

export const topcont = {
  paddingBottom: 64,
  [MediaQueries.sm]: {
    paddingBottom: 0,
    paddingTop: 0,
    width: '100%',
  },

  [MediaQueries.md]: {
    width: 'calc(100% - 40px)',
  },
  [MediaQueries.lg]: {
    paddingBottom: '48px',
  },
  [MediaQueries.md]: {
    paddingBottom: '10px',
  },
  [MediaQueries.sm]: {
    paddingBottom: '10px',
  },
};

export const topcontentsholder = {
  alignItems: 'flex-end',
  display: 'flex',

  minHeight: `calc(100vh - ${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px)`,

  [MediaQueries.sm]: {
    maxHeight: 'unset',
  },

  [MediaQueries.md]: {
    maxHeight: 1104,
  },

  [MediaQueries.mdAndUp]: {
    minHeight: `calc(100vh - ${NAV_MAX_HEIGHT}px)`,
  },

  [MediaQueries.lgAndUp]: {
    maxHeight: 1272,
  },
};

export const heading = css(typography.effra119, {
  '.linebreak': {
    display: 'block',
  },
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  margin: '0',
  marginBottom: 51,
  paddingRight: 30,
  position: 'relative',

  [MediaQueries.md]: {
    marginBottom: 100,
  },

  [MediaQueries.lgAndUp]: {
    marginBottom: 73,
  },
});

export const section = css(typography.effra16, {
  color: colorsPalette.red,
  fontWeights: fontWeights.regular,
  margin: 0,
});

export const subsection = css(
  {
    color: colorsPalette.grey80,
    fontWeights: fontWeights.regular,
    margin: 0,
    marginBottom: 26,

    [MediaQueries.md]: {
      marginBottom: 23,
    },

    [MediaQueries.lgAndUp]: {
      marginBottom: 0,
    },
  },
  typography.effra16,
);

export const descriptionLeft = css(typography.effra16, {
  color: colorsPalette.grey,
  fontWeights: fontWeights.regular,
  margin: 0,
  marginBottom: 30,

  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});

export const descriptionRight = css(typography.effra16, {
  color: colorsPalette.grey,
  fontWeights: fontWeights.regular,

  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
  },
});
